import moment from 'moment'
export default {
  methods: {
    getDayOfWeek:function(date = moment()){
      return moment(date).format('dd');
    },
    getTargetMonthStartDate: function (value) {
      return moment(value).startOf('month')
    },
    getTargetMonthEndDate: function (value) {
      return moment(value).endOf('month')
    },
    getStrYKanji: function (value) {
      return moment(value).format("YYYY年");
    },
    getStrYmKanji: function (value) {
      return moment(value).format("YYYY年MM月");
    },
    getStrMonthDayKanji:function(value){
      return moment(value).format("MM月DD日");
    },
    getStrYmdKanji: function (value) {
      return moment(value).format("YYYY年MM月DD日");
    },
    getStrMd: function (value) {
      return moment(value).format("MM/DD");
    },
    getStrYm: function (value) {
      return moment(value).format("YYYY-MM");
    },
    getNowYear: function () {
      return moment().get("year");
    },
    getNowMonth: function () {
      return moment().get('month') + 1;
    },
    getNowStrYear: function () {
      return moment().format("YYYY");
    },
    getNowStrMonth: function () {
      return moment().format("M")
    },
    getWarekiYear: function (year) {
      return new Date(year).toLocaleDateString('ja-JP-u-ca-japanese', {
        era: 'long',  // 時代 : 'narrow' にすると '平成' は 'H' になる
        year: 'numeric',  // 年 : 'ja-JP-u-ca-japanese' の場合は和暦
      });
    },
    // 
    getDate: function (value) {
      return moment(value).format("YYYY-MM-DD")
    },
    getStartOfYear:function(value){
      return moment(value).startOf('year').format("YYYY-MM-DD")
    },
    getEndOfYear:function(value){
      return moment(value).endOf('year').format("YYYY-MM-DD")
    },
    // 今月初
    getNowMonthStartDate: function (value) {
      return moment(value).startOf('month').format("YYYY-MM-DD");
    },
    // 今月末
    getNowMonthEndDate: function (value) {
      return moment(value).endOf('month').format("YYYY-MM-DD");
    },
    //日を取得
    getDay: function (value) {
      return moment(value).date();
    },
    getDefaultShowDate: function (value) {
      return moment(value).format("YYYY / MM / DD")
    },
    getStrDateSlash: function (value) {
      return moment(value).format("YYYY/MM/DD")
    },
    getStrDateHyphen: function (value) {
      return moment(value).format("YYYY-MM-DD");
    }
    ,
    getBeforeDate: function (value) {
      return moment(value).add(-1, "days").format();
    },
    getNextDate: function (value) {
      return moment(value).add(1, "days").format();
    },
    getStartWeek: function (value) {
      return moment(value).startOf('isoWeek').add(-1, "days").format("YYYY-MM-DD")
    },
    getEndWeek: function (value) {
      return moment(value).endOf('isoWeek').add(-1, 'days').format("YYYY-MM-DD");
    }


  }
}